import type { PromptDocument } from '../types'
import { interiorScheme } from './interior'
import { portraitScheme } from './portrait'
import { productScheme } from './product'

export const builtinSchemes: PromptDocument[] = [
  interiorScheme,
  portraitScheme,
  productScheme,
]

export function getBuiltinScheme(id: string): PromptDocument | undefined {
  return builtinSchemes.find(s => s.id === id)
}

export { interiorScheme, portraitScheme, productScheme }
export { buildBuiltinScheme, buildSection } from './builder'
